import { render, staticRenderFns } from "./Diet.vue?vue&type=template&id=68eacee6&scoped=true&"
import script from "./Diet.vue?vue&type=script&lang=js&"
export * from "./Diet.vue?vue&type=script&lang=js&"
import style0 from "./Diet.vue?vue&type=style&index=0&id=68eacee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eacee6",
  null
  
)

export default component.exports